const SEARCH_TERMS = [
  // 🔥 TRENDING NOW (from your data)
  "Bogg Bag dupe",
  "Hulken Bag dupe",
  "Oura Ring dupe",
  "Birkin dupe",
  "Goyard dupe",
  "Miu Miu sunglasses dupe",
  "Sand and Fog",
  "Kerastase night serum dupe",
  "Rhode glazing milk dupe",
  "City bag dupe",
  "Parallel makeup bag dupe",
  
  // 💄 PERFUME DUPES (high search volume)
  "Baccarat Rouge dupe",
  "Creed Aventus dupe",
  "Club de Nuit",
  "Afnan supremacy collector's edition",
  "Khadlaj island dreams dupe",
  "Rayhaan aquatica dupe",
  "Mojave Ghost dupe",
  "LV Imagination dupe",
  
  // 👗 CLOTHING DUPES
  "Lululemon Leggings dupe",
  "Skims dupe",
  "Alo Yoga dupe",
  "Free People Dress dupe",
  "Aritzia jacket dupe",
  "Ruti pants dupe",
  "Vuori shorts dupe",
  "Spanx leggings dupe",
  
  // 👟 SHOE DUPES
  "UGG Boots dupe",
  "Golden Goose Sneakers dupe",
  "Dr. Martens dupe",
  "On Cloud Shoes dupe",
  "New Balance 550 dupe",
  "Adidas Sambas dupe",
  "Hoka Shoes dupe",
  "Birkenstock Sandals dupe",
  
  // 🏠 HOME & FURNITURE DUPES
  "Pottery Barn dupe",
  "West Elm dupe",
  "Mackenzie Childs dupe",
  "Lola blanket dupe",
  "Le Creuset dupe",
  "Staub Dutch Oven dupe",
  
  // 💄 BEAUTY DUPES
  "La Mer dupe",
  "SK-II Essence dupe",
  "Tatcha Rice Wash dupe",
  "Nespresso Machine dupe",
  "Ninja Creami dupe",
  
  // 📈 BREAKOUT TERMS
  "Arc raiders dupe",
  "9pm night out dupe",
  "No prince required finery dupe",
  "Quince",
  "Dossier"
];

export default SEARCH_TERMS;